import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Textarea } from "@/components/ui/textarea";
import {
  Dialog,
  DialogHeader,
  DialogBody,
  DialogFooter,
} from "@/components/ui/dialog";
import { AdminDialogHeading } from "@/components/admin/AdminDialogHeading";
import { WarningCircle } from "@phosphor-icons/react";

export function BlogRejectDialog({
  isPending,
  onConfirm,
  onClose,
}: {
  isPending: boolean;
  onConfirm: (reason: string) => void;
  onClose: () => void;
}) {
  const [rejectReason, setRejectReason] = useState("");

  return (
    <Dialog open onClose={onClose}>
      <DialogHeader onClose={onClose}>
        <AdminDialogHeading
          icon={WarningCircle}
          title="Odbij članak"
          description="Navedite razlog odbijanja kako bi autor znao šta treba ispraviti."
          tone="warning"
        />
      </DialogHeader>
      <DialogBody className="flex flex-col gap-4">
        <Textarea
          placeholder="Razlog odbijanja (opcionalno)..."
          value={rejectReason}
          onChange={(e) => setRejectReason(e.target.value)}
          rows={4}
        />
      </DialogBody>
      <DialogFooter>
        <Button
          variant="outline"
          onClick={onClose}
        >
          Otkaži
        </Button>
        <Button
          variant="destructive"
          disabled={isPending}
          onClick={() => onConfirm(rejectReason)}
        >
          {isPending ? "Odbijanje..." : "Potvrdi odbijanje"}
        </Button>
      </DialogFooter>
    </Dialog>
  );
}
